/**
 *薪酬管理菜单
 */
export default [
  {
    label: 'statistics',  // 数据统计
    permission: 'hr_wage_new_report',
    img: true,
    icon: 'icon-tongjibaobiao',
    id:7,
    children: [
      {
        path: '/v2/stats/data-center-dashboard',
        label: 'dataCenter',  // 数据中心
        permission: 'hr_wage_new_report_data_center_zl',
        icon: 'icon-yonghu',
        id: 7-26
      },
      {
        path: '/v2/stats/emp-income/detail',
        label: 'staffIncomeDetails', // 员工收入明细表
        permission: 'hr_wage_new_report_xzmx',
        icon: 'icon-yonghu',
        id:7-21
      },
      {
        path: '/v2/stats/emp-income/detail-ruichen',
        label: 'staffIncomeDetailsForGroup', // 员工收入明细表
        permission: 'hr_wage_new_report_xzmx_rc',
        icon: 'icon-yonghu',
        id:7-22
      },
      {
        path: '/v2/stats/emp-income/summary',
        label: 'staffIncomeSummary', // 员工收入汇总表
        permission: 'hr_wage_new_report_ndpjgz',
        icon: 'icon-yonghu',
        id:7-23
      },
      {
        path: '/v2/stats/data-center',
        label: 'dataCenter',  // 数据中心
        permission: 'hr_wage_new_report_data_center',
        icon: 'icon-yonghu',
        id: 7-24
      },
      {
        path: '/v2/stats/emp-income/detailtabs',
        label: 'staffIncomeDetailsPerTaxType', // 员工收入明细表分计税类型报表
        permission: 'hr_wage_new_report_per_taxtype_xzmx',
        icon: 'icon-yonghu',
        id:7-25
      },

      /*{
        path: '/wage/data-ready-template',
        label: '报表统计',
        permission: 'wage_data-ready-template_temp',
        icon: 'icon-yonghu',
        id:6-1
      },*/
      /*{
        path: '/wage/wageComparisonColumnsList',
        label: '工资对比报表',
        permission: 'wage_salary_yop',
        icon: 'icon-yonghu',
        id: 6-2,
      },*/
      // {
      //   path: '/wage/costCenterSummaryColumnsList',
      //   label: 'costCenterSummary', // 成本中心汇总表
      //   permission: 'hr_wage_new_report_cbzx',
      //   icon: 'icon-yonghu',
      //   id: 7-3,
      // },
/*      {
        path: '/wage/taxRateSummaryList',
        label: '税率汇总报表',
        permission: 'wage_salary_yop',
        icon: 'icon-yonghu',
        id: 6-4,
      },*/
      /*{
        path: '/wage/averageWageColumnsList',
        label: '平均工资报表',
        permission: 'wage_salary_yop',
        icon: 'icon-yonghu',
        id: 6-5,
      },*/
			{
				path: '/report/wageComparison',
				label: 'salaryComparison', // 工资对比表
				permission: 'hr_wage_new_report_gzdb',
				icon: 'icon-yonghu',
				id: 7-2,
			},
      {
        path: '/report/annualWage',
        label: 'costCenterComparison', // 成本中心对比表
        permission: 'hr_wage_new_report_cbzxdb',
        icon: 'icon-yonghu',
        id:7-6
      },
      // {
      //   path: '/report/averageWage',
      //   label: '年度工资汇总表',
      //   permission: 'hr_wage_new_report_ndpjgz',
      //   icon: 'icon-yonghu',
      //   id:7-7
      // },
      // {
      //   path: '/report/annualAverageWage',
      //   label: '年度平均工资表',
      //   permission: 'hr_wage_new_report_ndpjgz',
      //   icon: 'icon-yonghu',
      //   id:7-8
      // },
      // {
      //   path: '/report/payReport',
      //   label: '雇员发薪明细',
      //   permission: 'hr_wage_new_report_xzmx',
      //   icon: 'icon-yonghu',
      //   id:7-9
      // },
      {
        path: '/report/ReportCli',
        label: 'customReport', // 自定义报表
        permission: 'hr_wage_new_report_zdybb',
        icon: 'icon-yonghu',
        id: 7-10,
      },

    ]
  },
  {
    label: 'sishangReport',  // 四上报表
    permission: 'set_ssbb_report',
    img: true,
    icon: 'icon-tongjibaobiao',
    id:20,
    paid: true,
    children: [
      {
        path: '/v2/sishang/company',
        label: 'enterpriseInformation',  // 企业信息
        permission: 'set_ssbb_report_firm',
        icon: 'icon-yonghu',
        id: 7-11,
      },
      {
        path: '/v2/sishang/report',
        label: 'sishangEnterpriseReport',  // 四上企业报表
        permission: 'set_ssbb_report_report',
        icon: 'icon-yonghu',
        id: 7-11,
      }
    ]
  },
  {
    label: 'auditReport',  // 审计报表
    permission: 'set_sjbb_audit',
    img: true,
    icon: 'icon-tongjibaobiao',
    id: 22,
    children: [
      {
        path: '/audit_forward_xsyrzxq',
        label: 'payTaxCloudLogDetails', // 薪税云日志详情
        permission: 'audit_forward_xsyrzxq',
        icon: 'icon-yonghu',
        id: 22-1
      },
      {
        path: '/audit_forward_xsyrfwtj',
        label: 'payTaxCloudDailyVisitStatistics',  // 薪税云日访问统计
        permission: 'audit_forward_xsyrfwtj',
        icon: 'icon-yonghu',
        id: 22-2
      },
      {
        path: '/audit_forward_xcyrzxq',
        label: 'payCloudLogDetails', // 薪酬云日志详情
        permission: 'audit_forward_xcyrzxq',
        icon: 'icon-yonghu',
        id: 22-3
      }
    ]
  }
]
